<div class="cg-dialog">
  <h2 class="cg-dialog__header">
    Site Help<button
      cignaButton="link inline no-underline"
      class="cg-dialog__close_new"
      (click)="dialogRef.close()"
    >
      Close
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <p>
      View below for a list of frequently asked site questions. Please call us
      at 1 (800) 981-9114 if your question is not addressed below.
    </p>
    <cigna-collapsible-item
      headerText="Who can sign up for the Cigna for Health Care Professionals portal?"
    >
      <p>
        Medical, dental, and behavioral professionals, as well as their staff,
        can sign up for an account. You'll need your organization's Tax ID
        number (TIN) to register.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="I'm not contracted with Cigna Healthcare. Can I still register?"
    >
      <p>
        Yes, if you aren’t contracted, you can still sign up if you've sent a
        claim to Cigna Healthcare.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="Do I need a separate username and password to access combined medical, dental, and behavioral information?"
    >
      <p>
        You can use the same username and password to access Medical and
        Behavioral information. You will need separate accounts if you want to
        access Dental and Medical information or Dental and Behavioral
        information.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Can I register for more than one TIN?">
      <p>
        During the registration process, you can add up to 50 TINs to a user ID.
        After registration, you don’t need to add a new account as you can
        request additional TIN access under “Settings & Preferences”.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="What's a website access manager?">
      <p>
        A website access manager is a user who manages the group's registrations
        and each user's level of access. They can:
      </p>
      <ol>
        <li>Approve new users</li>
        <li>Assign or modify website functions</li>
        <li>Remove access for users who no longer need it</li>
      </ol>
      <p>
        There is a limit of 15 website access managers per group. We suggest
        assigning as few website access managers as possible.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="I represent a billing company for multiple practitioners. How do I register?"
    >
      <p>
        Please reach out to each practice for access. The practice will be able
        to grant access to their specific TINs.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="I filled out the registration but still can’t access the site."
    >
      <p>
        You will be unable to login until your website access manager has
        approved your access.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="I can log in but can't get the info I need on the site (for example, patient and claim details)?"
    >
      <p>
        You may not have the appropriate level of access. Contact your website
        access manager for the necessary permissions. You can find the name of
        your website access manager by locating your name at the top right and
        selecting “Settings & Preferences”. Then click on “Online Access” in the
        lefthand column and then choose the “View access rights” link on the
        right. Select a TIN from the dropdown and scroll to the bottom to view
        the website access managers for that TIN.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="What if I don't know who my website access manager is?"
    >
      <p>
        For security reasons, website access manager information is only
        available to authorized users post-login. Our team will not be able to
        provide this information to you over the phone. We recommend reaching
        out to someone in your practice for website access manager information.
        However, if you’re the first person assigned to a TIN, we will reach out
        to you about website access managers and next steps in the registration
        process.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Any other site questions?">
      <p>Contact our support team at 1 (800) 981-9114 for help.</p>
    </cigna-collapsible-item>
  </mat-dialog-content>
</div>
